import { SET_ERROR } from "./types";
import store from "../../redux";
import { renderChat } from "./chatActions";
import { onWsConnectionNetworkErrorEventHandler } from "../../redux/actions/amazonConnectActions";
import { ConnectAccessDeniedError } from "../../common/CustomError";
import { logger } from "../../common/Logger";
import { UnKnownError } from "../../common/CustomError";
import { setIsChatEnabled } from "../../redux/actions/messagePaneActions";

export const setError = (errorPane) => (dispatch) => {
  const renderErrorPane = (retryAction) => {
    dispatch(
      renderChat({
        errorPane: {
          error: store.getState().errorReducer.errorPane.error,
          retryAction: retryAction,
          errorCode: store.getState().errorReducer.errorPane.errorCode,
        },
      })
    );
  };
  try {
    dispatch({ type: SET_ERROR, payload: { errorPane } });
    console.error(
      "setError Error",
      store.getState().errorReducer.errorPane.retryAction
    );

    switch (store.getState().errorReducer.errorPane.errorCode) {
      case "E001":
        renderErrorPane(errorPane.retryAction);
        console.debug("errorpane1");
        break;
      case "E002":
        renderErrorPane(errorPane.retryAction);
        console.debug("errorpane2");
        break;
      case "E003":
        renderErrorPane(errorPane.retryAction);
        console.debug("errorpane3");
        break;
      case "E004":
        if (
          !dispatch(
            onWsConnectionNetworkErrorEventHandler(
              store.getState().errorReducer.errorPane.error.toString()
            )
          )
        ) {
          dispatch(
            setIsChatEnabled({
              isConnectParticipantTokenInvalid:
                store.getState().errorReducer.errorPane.error instanceof
                ConnectAccessDeniedError,
            })
          );
          renderErrorPane(errorPane.retryAction);
          //need this render, triggers retry after "CTM_test":"trigger-ws-connection-403"
        }
        console.debug("errorpane4");
        console.debug(
          "setError Refresh",
          store.getState().errorReducer.errorPane.retryAction
        );
        break;
      case "E005":
        if (
          !dispatch(
            onWsConnectionNetworkErrorEventHandler(
              store.getState().errorReducer.errorPane.error.toString()
            )
          )
        ) {
          dispatch(
            setIsChatEnabled({
              isConnectParticipantTokenInvalid:
                store.getState().errorReducer.errorPane.error instanceof
                ConnectAccessDeniedError,
            })
          );
          if (
            store.getState().messagePaneReducer.isChatEnabled
              .isConnectParticipantTokenInvalid &&
            store.getState().messagePaneReducer.messageList.length > 0
          ) {
            dispatch(
              renderChat({
                from: "M004",
                messagePane: { messagePaneReady: true },
              })
            );
          } else {
            renderErrorPane(errorPane.retryAction);
          }
        }
        console.debug("errorpane5");
        break;
      case "E006":
        if (
          !store.getState().messagePaneReducer.isChatEnabled.restartFlag &&
          !store.getState().messagePaneReducer.isChatEnabled.isNetworkError
        ) {
          renderErrorPane(errorPane.retryAction);
        }

        console.debug("errorpane6");
        break;
      case "E007":
        if (
          !store.getState().messagePaneReducer.isChatEnabled.restartFlag &&
          !store.getState().messagePaneReducer.isChatEnabled.isNetworkError
        ) {
          if (
            !(
              store.getState().errorReducer.errorPane.error instanceof
              UnKnownError
            )
          )
            renderErrorPane(errorPane.retryAction);
          throw store.getState().errorReducer.errorPane.error;
        }
        console.debug("errorpane7");
        break;
      case "E008":
        renderErrorPane(errorPane.retryAction);
        console.debug("errorpane8");
        break;
      case "E009":
        renderErrorPane(errorPane.retryAction);
        console.debug("errorpane9");
        break;
      case "E010":
        if (
          dispatch(
            onWsConnectionNetworkErrorEventHandler(
              store.getState().errorReducer.errorPane.error.toString()
            )
          )
        ) {
          return;
        } else {
          logger.error(
            "sendChatMessageToConnect error : ",
            store.getState().errorReducer.errorPane.error
          );
          renderErrorPane(errorPane.retryAction);
        }
        console.debug("errorpane10");
        break;
      case "E011":
        renderErrorPane(errorPane.retryAction);
        console.debug("errorpane11");
        break;
      case "E012":
        renderErrorPane(errorPane.retryAction);
        console.debug("errorpane12");
        break;
      case "E013":
        renderErrorPane(errorPane.retryAction);
        console.debug("errorpane13");
        break;
      case "E014":
        if (
          dispatch(
            onWsConnectionNetworkErrorEventHandler(
              store.getState().errorReducer.errorPane.error.toString()
            )
          )
        ) {
          return;
        } else if (
          store.getState().errorReducer.errorPane.error instanceof
          ConnectAccessDeniedError
        ) {
          dispatch(
            setIsChatEnabled({
              isConnectParticipantTokenInvalid: true,
            })
          );
          // nextRenderOfChatPane({
          //   from: "33",
          //   messagePane: { messagePaneReady: true },
          // });
        } else {
          logger.error(
            "sendChatMessageToConnect error : ",
            store.getState().errorReducer.errorPane.error
          );
          dispatch(
            renderChat({
              errorPane: {
                error: store.getState().errorReducer.errorPane.error,
                retryAction:
                  store.getState().errorReducer.errorPane.retryAction,
                errorCode: store.getState().errorReducer.errorPane.errorCode,
              },
            })
          );
        }
        console.debug("errorpane14");
        break;
      default:
        console.debug("errorpane default");
        break;
    }
  } catch (error) {
    console.debug("setError Error", error);
  }
};
